/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type UpdateVolunteerShiftMutationVariables = Types.Exact<{
  data: Types.VolunteerShiftUpdateInput;
  id: Types.Scalars["Int"];
}>;

export type UpdateVolunteerShiftMutation = {
  updateVolunteerShift: Pick<
    Types.VolunteerShift,
    | "shift_id"
    | "category_name"
    | "registration_open"
    | "organizer_responsible_user_id"
    | "description"
    | "createdAt"
  > & {
    category: Pick<Types.VolunteerCategory, "name" | "primary_only">;
    shift: Pick<
      Types.EventActivity,
      "category" | "created_at" | "end_time" | "id" | "location"
    >;
  };
};

export const UpdateVolunteerShiftDocument = gql`
  mutation UpdateVolunteerShift($data: VolunteerShiftUpdateInput!, $id: Int!) {
    updateVolunteerShift(data: $data, id: $id) {
      shift_id
      category_name
      registration_open
      organizer_responsible_user_id
      description
      createdAt
      category {
        name
        primary_only
      }
      shift {
        category
        created_at
        end_time
        id
        location
      }
    }
  }
`;

/**
 * __useUpdateVolunteerShiftMutation__
 *
 * To run a mutation, you first call `useUpdateVolunteerShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVolunteerShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVolunteerShiftMutation, { data, loading, error }] = useUpdateVolunteerShiftMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateVolunteerShiftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVolunteerShiftMutation,
    UpdateVolunteerShiftMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateVolunteerShiftMutation,
    UpdateVolunteerShiftMutationVariables
  >(UpdateVolunteerShiftDocument, baseOptions);
}
export type UpdateVolunteerShiftMutationHookResult = ReturnType<
  typeof useUpdateVolunteerShiftMutation
>;
export type UpdateVolunteerShiftMutationResult =
  ApolloReactCommon.MutationResult<UpdateVolunteerShiftMutation>;
export type UpdateVolunteerShiftMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateVolunteerShiftMutation,
    UpdateVolunteerShiftMutationVariables
  >;
